import PropTypes from 'prop-types';

export default function VideoBackground({ overlay, video, show = true }) {
  return (
    <div
      className={`relative -z-10 overflow-hidden pointer-events-none w-full h-full ${show ? 'opacity-100' : 'opacity-0'} transition-opacity`}
    >
      <div
        className={`absolute z-10 bg-black transition-opacity ${overlay ? 'opacity-50' : 'opacity-0'} top-0 bottom-0 left-0 right-0`}
      />
      <video
        className="absolute w-full h-full min-h-full object-cover bg-cover bg-center"
        playsInline
        autoPlay
        muted
        loop
      >
        <source src={video.webm} type="video/webm" />
        <source src={video.mp4} type="video/mp4" />
      </video>
    </div>
  );
}

VideoBackground.propTypes = {
  overlay: PropTypes.bool,
  show: PropTypes.bool,
  video: PropTypes.shape({
    webm: PropTypes.string,
    mp4: PropTypes.string,
  }),
};
